import React from 'react';
import PropTypes from 'prop-types';
import { Grid } from 'semantic-ui-react';
import Markdown from 'markdown-to-jsx';

export default function ContentMarkup({ children, content, isMarkdown, ...gridColumnProps }) {
  const finalContent = content || children;

  if (!finalContent) {
    return null;
  }

  return (
    <Grid.Column {...gridColumnProps}>
      {isMarkdown && <Markdown>{finalContent}</Markdown>}
      {!isMarkdown && finalContent}
    </Grid.Column>
  );
};

ContentMarkup.propTypes = {
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.arrayOf(PropTypes.node)]),
  content: PropTypes.string,
  isMarkdown: PropTypes.bool,
};

ContentMarkup.defaultProps = {
  children: null,
  content: null,
  isMarkdown: true,
};
